import { useEffect, useState } from 'react'
import { useViewportMode } from './useViewportMode'

/**
 * Theo dõi một media query. Trả về false khi SSR / chưa mount.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/**
 * Đang ở giao diện mobile hay không.
 *
 * Giữ nguyên tên hàm để các chỗ đang gọi (`DataTable`) không phải
 * sửa, nhưng ruột đã đổi: trước đây là `(max-width: 767px)` — một ngưỡng RIÊNG,
 * lệch với ngưỡng `lg:` của khung layout, khiến 768–1023px (iPad dọc) có thanh
 * tab đáy mobile mà bảng vẫn vẽ kiểu desktop. Nay dùng chung một nguồn sự thật.
 *
 * @see useViewportMode
 */
export function useIsMobile(): boolean {
  return useViewportMode() === 'mobile'
}
